const styles = {
  font: '16px Roboto, sans-serif',
  WebkitFontSmoothing: 'antialiased',
};

export default styles;
